import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  generateFloodSummary({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.FloodReport.floodOrderSummary}/${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  upgradeLifeOfLoanClicked({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.FloodReport.upgradeLifeOfLoan}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  transferToLenderClicked({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.FloodReport.transferToLenderList}/${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  recertifyClicked({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.FloodReport.recertify}`
    return axios
      .post(url, payload, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  transferToLenderProceed({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.FloodReport.transferToLender}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
